export default {
  common: {
    welcome: '欢迎访问',
    create: '确认新建',
    update: '确认编辑',
    cancel: '取消',
    delete: '删除',
    success: {
      deleted: '删除{0}成功',
      created: '创建{0}成功',
      edited: '编辑{0}成功',
      updated: '更新{0}成功',
      refresh: '刷新{0}成功'
    },
    fail: {
      deleted: '删除{0}失败',
      created: '创建{0}失败',
      edited: '编辑{0}失败',
      updated: '更新{0}失败',
      refresh: '刷新{0}失败'
    }
  }
}
